import { theme } from './global.js';

class CategoryMenu extends HTMLElement {
  constructor() {
    super();
    this.trigger = this.querySelector('.all-categories__trigger');
    this.panel = this.querySelector('.all-categories__panel');
    this.showMoreBtn = this.querySelector('[data-show-more]');
    if (!this.trigger || !this.panel) return;

    this.hoverMedia = window.matchMedia('(hover: hover) and (pointer: fine)');
    this.trigger.addEventListener('click', () => (this.hoverMedia.matches ? this.open() : this.toggle()));
    this.addEventListener('mouseenter', () => {
      if (!this.hoverMedia.matches) return;
      clearTimeout(this.closeTimer);
      this.open();
    });
    this.addEventListener('mouseleave', () => {
      if (!this.hoverMedia.matches) return;
      clearTimeout(this.closeTimer);
      this.closeTimer = setTimeout(() => this.close(), 150);
    });
    document.addEventListener('click', (e) => {
      if (!this.contains(e.target)) this.close();
    });
    this.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        this.close();
        this.trigger.focus();
      }
    });

    this.querySelectorAll('.all-categories__item.has-children > .all-categories__link').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (window.matchMedia('(hover: none)').matches) {
          e.preventDefault();
          this.toggleFlyout(link.closest('.all-categories__item'));
        }
      });
      link.addEventListener('focus', () => this.openFlyout(link.closest('.all-categories__item')));
      link.closest('.all-categories__item').addEventListener('mouseenter', () => {
        if (this.hoverMedia.matches) this.openFlyout(link.closest('.all-categories__item'));
      });
    });

    this.querySelectorAll('.all-categories__item:not(.has-children)').forEach((item) => {
      item.addEventListener('mouseenter', () => {
        if (this.hoverMedia.matches) this.querySelectorAll('.all-categories__item.is-open').forEach((el) => el.classList.remove('is-open'));
      });
    });

    this.showMoreBtn?.addEventListener('click', () => this.toggleOverflow());
  }

  toggle() {
    this.panel.classList.contains('is-open') ? this.close() : this.open();
  }

  open() {
    clearTimeout(this.hideTimer);
    if (this.panel.hidden) {
      this.panel.hidden = false;
      // Force a reflow so the entry transition runs from the closed state.
      void this.panel.offsetWidth;
    }
    this.setAttribute('open', '');
    this.panel.classList.add('is-open');
    this.trigger.setAttribute('aria-expanded', 'true');
  }

  close() {
    if (this.panel.hidden) return;
    this.removeAttribute('open');
    this.panel.classList.remove('is-open');
    this.trigger.setAttribute('aria-expanded', 'false');
    this.querySelectorAll('.all-categories__item.is-open').forEach((item) => item.classList.remove('is-open'));
    // Hide it for assistive tech and the tab order once the exit animation has finished.
    clearTimeout(this.hideTimer);
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    this.hideTimer = setTimeout(() => { this.panel.hidden = true; }, reduce ? 0 : 230);
  }

  toggleFlyout(item) {
    const isOpen = item.classList.contains('is-open');
    this.querySelectorAll('.all-categories__item.is-open').forEach((el) => el.classList.remove('is-open'));
    if (!isOpen) item.classList.add('is-open');
  }

  openFlyout(item) {
    this.querySelectorAll('.all-categories__item.is-open').forEach((el) => el.classList.remove('is-open'));
    item.classList.add('is-open');
  }

  toggleOverflow() {
    const hiddenItems = [...this.querySelectorAll('[data-overflow]')];
    if (!hiddenItems.length) return;
    clearTimeout(this.overflowTimer);
    const expand = hiddenItems[0].hidden;
    const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    const count = hiddenItems.length;
    if (expand) {
      hiddenItems.forEach((el, i) => {
        el.hidden = false;
        el.style.setProperty('--i', i);
        el.classList.remove('is-leaving');
        el.classList.add('is-entering');
      });
      this.overflowTimer = setTimeout(() => hiddenItems.forEach((el) => el.classList.remove('is-entering')), reduce ? 0 : 260 + count * 35);
    } else {
      hiddenItems.forEach((el, i) => {
        el.style.setProperty('--i', count - 1 - i);
        el.classList.remove('is-entering');
        el.classList.add('is-leaving');
      });
      this.overflowTimer = setTimeout(() => hiddenItems.forEach((el) => {
        el.hidden = true;
        el.classList.remove('is-leaving');
      }), reduce ? 0 : 200 + count * 25);
    }
    this.showMoreBtn.textContent = expand ? theme.strings.showLess || 'Show less' : theme.strings.showMore || 'Show more';
  }
}

customElements.define('category-menu', CategoryMenu);
